var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum, IsOptional, IsString } from "class-validator";
export const agentStatusType = "io.healthex.agentstatus";
export var AgentErrorType;
(function (AgentErrorType) {
    AgentErrorType["AGENT_UNREACHABLE"] = "AGENT_UNREACHABLE";
    AgentErrorType["PATIENT_INGEST_FAILED"] = "PATIENT_INGEST_FAILED";
    AgentErrorType["PATIENT_CONTACT_FETCH_FAILED"] = "PATIENT_CONTACT_FETCH_FAILED";
    AgentErrorType["PATIENT_FULL_RECORD_FETCH_FAILED"] = "PATIENT_FULL_RECORD_FETCH_FAILED";
})(AgentErrorType || (AgentErrorType = {}));
export class AgentStatus {
    constructor(fields) {
        this.type = agentStatusType;
        Object.assign(this, fields);
    }
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], AgentStatus.prototype, "healthy", void 0);
__decorate([
    IsEnum(AgentErrorType, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], AgentStatus.prototype, "errors", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], AgentStatus.prototype, "version", void 0);
__decorate([
    IsString(),
    __metadata("design:type", Object)
], AgentStatus.prototype, "type", void 0);
